import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiHelperFunction from "../../api";
import {
  FormDataType,
  initialStateProps,
  IncorporationPayload,
} from "./interface";
import { encodeStorageKey, toStorageKey } from "../../utils/fileUrl";

// Define a type for the payload

/**
 * API calling
 *
 *
 */

export const getOrderList = createAsyncThunk(
  "admin/get-order-details",
  async (
    {
      userId,
      offset = 0,
      limit = 10,
      search = "",
      start_date = "",
    }: {
      offset?: number;
      limit?: number;
      userId?: number;
      search: "";
      start_date?: string;
    },
    { dispatch },
  ) => {
    const token = localStorage.getItem("user_token");

    const queryParams = new URLSearchParams({
      offset: offset.toString(),
      limit: limit.toString(),
    });
    if (search) {
      queryParams.append("search", search);
    }
    if (start_date) {
      queryParams.append("start_date", start_date);
    }

    const response = await ApiHelperFunction({
      url: `get-orders-list/${userId}?order_type=llc&${queryParams}`,
      method: "get",
      dispatch,
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `${token}` : "",
      },
    });

    return {
      data: response?.data?.data || [],
      total_records: response?.data?.total_records || 0,
    };
  },
);

export const getCompanyList = createAsyncThunk(
  "/get-all-company-list/",
  async (payload: { search: string; product_id: number }, { dispatch }) => {
    const token = localStorage.getItem("user_token");
    const response = await ApiHelperFunction({
      url: `/get-all-company-list/?search=${payload?.search}&product_id=${payload?.product_id}`, // end point
      method: "get", // method
      data: payload,
      dispatch,
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `${token}` : "",
      },
    });
    let resData = response?.data;
    return resData;
  },
);
export const createIncorpartion = createAsyncThunk(
  "create-incorporation/",
  async (payload: any, { dispatch }) => {
    try {
      const token = localStorage.getItem("user_token");
      const response = await ApiHelperFunction({
        url: "create-incorporation/", // end point
        method: "post", // method
        data: payload, // payload data
        dispatch,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: token ? `${token}` : "",
        },
      });

      let resData = response?.data;
      return resData;
    } catch (error) {
      return error;
    }
  },
);

export const updateIncorpartion = createAsyncThunk(
  "update-incorporation/",
  async (payload: FormData, { dispatch }) => {
    const token = localStorage.getItem("user_token");
    const response = await ApiHelperFunction({
      url: "update-incorporation/", // end point
      method: "post", // method
      data: payload, // payload data
      dispatch,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: token ? `${token}` : "",
      },
    });

    let resData = response?.data;
    return resData;
  },
);
export const getIndustryData = createAsyncThunk(
  "get-industry-type-list/",
  async (payload: any, { dispatch }) => {
    const token = localStorage.getItem("user_token");
    const response = await ApiHelperFunction({
      url: "get-industry-type-list/", // end point
      method: "get", // method
      data: payload, // payload data
      dispatch,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: token ? `${token}` : "",
      },
    });

    let resData = response?.data;
    return resData;
  },
);
export const getCountryList = createAsyncThunk(
  "get-countries-list/",
  async (payload: any, { dispatch }) => {
    const token = localStorage.getItem("user_token");
    const response = await ApiHelperFunction({
      url: "get-countries-list/", // end point
      method: "get", // method
      data: payload, // payload data
      dispatch,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: token ? `${token}` : "",
      },
    });

    let resData = response?.data;
    return resData;
  },
);
export const getStateList = createAsyncThunk(
  "get-states-list/",
  async (payload: any, { dispatch }) => {
    const token = localStorage.getItem("user_token");
    const response = await ApiHelperFunction({
      url: "get-states-list/", // end point
      method: "get", // method
      data: payload, // payload data
      dispatch,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: token ? `${token}` : "",
      },
    });

    let resData = response?.data;
    return resData;
  },
);
export const getCompanyTypeList = createAsyncThunk(
  "get-company-type-list/",
  async (payload: any, { dispatch }) => {
    const token = localStorage.getItem("user_token");
    const response = await ApiHelperFunction({
      url: "get-company-type-list/", // end point
      method: "get", // method
      data: payload, // payload data
      dispatch,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: token ? `${token}` : "",
      },
    });

    let resData = response?.data;
    return resData;
  },
);
export const getIncorporationList = createAsyncThunk(
  "get-incorporation/",
  async (payload: { order_id?: string }, { dispatch }) => {
    try {
      const token = localStorage.getItem("user_token");
      const queryParams = payload.order_id
        ? `?order_id=${payload.order_id}`
        : "";

      const response = await ApiHelperFunction({
        url: `get-incorporation/${queryParams}`,
        method: "get",
        data: payload,
        dispatch,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: token ? `${token}` : "",
        },
      });

      let resData = response?.data;

      return resData;
    } catch (error) {
      return error;
    }
  },
);

export const getUrl = createAsyncThunk(
  "download/",
  async (payload: { url?: string }, { dispatch }) => {
    const token = localStorage.getItem("user_token");
    const key = toStorageKey(payload.url);
    if (!key) {
      return { status: 0, message: "This file is not available yet." };
    }
    const queryParams = `?url=${encodeStorageKey(key)}`;

    const response = await ApiHelperFunction({
      url: `download/${queryParams}`,
      method: "get",
      data: payload,
      dispatch,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: token ? `${token}` : "",
      },
    });

    let resData = response?.data;

    return resData;
  },
);

export const getDashboradData = createAsyncThunk(
  "dashboard/",
  async (payload: any, { dispatch }) => {
    const token = localStorage.getItem("user_token");
    const response = await ApiHelperFunction({
      url: "dashboard/", // end point
      method: "get", // method
      data: payload, // payload data
      dispatch,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: token ? `${token}` : "",
      },
    });

    let resData = response?.data;
    return resData;
  },
);

export const getComplicance = createAsyncThunk(
  "get-compliance/",
  async (payload: { offset: number; limit: number }, { dispatch }) => {
    const token = localStorage.getItem("user_token");
    const response = await ApiHelperFunction({
      url: `get-compliance/?offset=${payload.offset}&limit=${payload.limit}`,
      method: "get",
      dispatch,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: token ? `${token}` : "",
      },
    });

    let resData = response?.data;
    return resData;
  },
);

/**
 * The initial state of the auth slice.
 */
export const initialState: initialStateProps = {
  status: "idle",
  error: "string",
  FrormData: [],
  token: " string",
  countryList: [],
  industryList: [],
  compnayTypeList: [],
  incorporationDetails: [],
  data: [],
  stateList: [],
  total_records: 0,
  records_limit: 10,
  companyList: [],
  companyListStatus: "idle",
};

/**
 * The auth slice.
 */
export const incorporationSlice = createSlice({
  name: "incorporation",
  initialState,
  reducers: {
    restAll: (state) => {
      state.error = "";
    },
  },
  extraReducers(builder) {
    builder
      .addCase(createIncorpartion.pending, (state) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(createIncorpartion.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.FrormData = action.payload?.user || [];

        // state.UserResponse = action.payload || [];
      })
      .addCase(createIncorpartion.rejected, (state, action) => {
        state.status = "failed";
      })
      .addCase(getCountryList.pending, (state) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(getCountryList.fulfilled, (state, action) => {
        state.status = "succeeded";

        state.countryList = action.payload?.data || [];

        // state.UserResponse = action.payload || [];
      })
      .addCase(getCountryList.rejected, (state, action) => {
        state.status = "failed";
      })
      .addCase(getStateList.pending, (state) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(getStateList.fulfilled, (state, action) => {
        state.status = "succeeded";

        state.stateList = action.payload?.data || [];

        // state.UserResponse = action.payload || [];
      })
      .addCase(getStateList.rejected, (state, action) => {
        state.status = "failed";
      })
      .addCase(getIndustryData.pending, (state) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(getIndustryData.fulfilled, (state, action) => {
        state.status = "succeeded";

        state.industryList = action.payload?.data || [];

        // state.UserResponse = action.payload || [];
      })
      .addCase(getIndustryData.rejected, (state, action) => {
        state.status = "failed";
      })
      .addCase(getCompanyTypeList.pending, (state) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(getCompanyTypeList.fulfilled, (state, action) => {
        state.status = "succeeded";

        state.compnayTypeList = action.payload?.data || [];
      })
      .addCase(getCompanyTypeList.rejected, (state, action) => {
        state.status = "failed";
      })

      .addCase(getIncorporationList.pending, (state) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(getIncorporationList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.incorporationDetails = action.payload?.data || [];
      })
      .addCase(getIncorporationList.rejected, (state, action) => {
        state.status = "failed";
      })
      .addCase(getDashboradData.pending, (state) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(getDashboradData.fulfilled, (state, action) => {
        state.status = "succeeded";

        state.data = action.payload?.data || [];

        // state.UserResponse = action.payload || [];
      })
      .addCase(getDashboradData.rejected, (state, action) => {
        state.status = "failed";
      })
      // ✅ Get User List
      .addCase(getOrderList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getOrderList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload.data;
        // console.log(state.data,"action.payload.data");
        state.total_records = action.payload.total_records;
      })
      .addCase(getOrderList.rejected, (state, action) => {
        state.status = "failed";
        // state.error = action.error.message;
      })
      .addCase(getCompanyList.pending, (state) => {
        state.companyListStatus = "loading";
        state.error = "";
      })
      .addCase(getCompanyList.fulfilled, (state, action) => {
        state.companyListStatus = "succeeded";
        state.companyList = action.payload.data;
        console.log(state.companyList, "state.companyList");
      })
      .addCase(getCompanyList.rejected, (state, action) => {
        state.companyListStatus = "failed";
      });
  },
});

export const { restAll } = incorporationSlice.actions;

export default incorporationSlice.reducer;
